export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torsos-b2203215a3a67e1d76504d5f06a1b8a4.svg";